// Note: SignalR "Invocation canceled" error suppression is handled in public/index.html
// which loads BEFORE any JavaScript bundles, ensuring the handlers are registered
// before React's error overlay can intercept the errors.
//
// Entry bootstrapper: keep this file tiny. The sign-in pages (`/login`, `/register`, …) and the
// signed-in app (`/v2/*`) are separate chunks so a visitor who only signs in never downloads
// the main app up front. See docs/AuthPages.md.

import { isAuthPath } from "./auth/authRoutes";
import { getStoredLocale, loadMessages } from "./i18n/locales";

const container = document.getElementById("root") as HTMLElement;
const locale = getStoredLocale();

if (isAuthPath(window.location.pathname)) {
  Promise.all([import(/* webpackChunkName: "auth" */ "./auth/AuthApp"), loadMessages(locale)]).then(
    ([auth, messages]) => auth.mount(container, locale, messages)
  );
} else {
  Promise.all([import(/* webpackChunkName: "app" */ "./MainRoot"), loadMessages(locale)]).then(
    ([main, messages]) => main.mount(container, locale, messages)
  );
}
